import { createAction } from './create-action';
import { createCustomAction } from './create-custom-action';
import { createStandardAction } from './create-standard-action';

export default { createAction, createCustomAction, createStandardAction };
